import { aboutData } from '@/mocks/homeData';

export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-6">
            {aboutData.title}
          </h2>
          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>{aboutData.desc1}</p>
            <p>{aboutData.desc2}</p>
            <p>{aboutData.desc3}</p>
          </div>

          <div className="grid grid-cols-3 gap-4 md:gap-8 mt-10 pt-8 border-t border-background-200/70">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-black text-primary-600 font-heading">5万+</div>
              <div className="text-xs text-foreground-500 mt-1">影视资源</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-black text-accent-500 font-heading">日更200+</div>
              <div className="text-xs text-foreground-500 mt-1">实时更新</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-black text-secondary-600 font-heading">零缓冲</div>
              <div className="text-xs text-foreground-500 mt-1">流畅体验</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}